import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';

const BrandForm = ({ onSubmit, initBrand = {}, readOnly, loading }) => {
  const methods = useForm({ defaultValues: initBrand });
  return (
    <FormProvider {...methods}>
      <form id="brand-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Назва марки"
          type="input"
          name="name"
          autoFocus="true"
          disabled={readOnly || loading}
          placeholder={'Введіть назву марки'}
          validation={notBlankValidation}
        />
      </form>
    </FormProvider>
  );
};

export default BrandForm;
